import { render, staticRenderFns } from "./LayoutEditBauvorhaben.vue?vue&type=template&id=45fdbe29&scoped=true"
import script from "./LayoutEditBauvorhaben.vue?vue&type=script&lang=js"
export * from "./LayoutEditBauvorhaben.vue?vue&type=script&lang=js"
import style0 from "./LayoutEditBauvorhaben.vue?vue&type=style&index=0&id=45fdbe29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fdbe29",
  null
  
)

export default component.exports